// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../../utils'

export { MethodContainer as Container } from '../elements'

export const ConfirmationRow = styled('div', {
  width: '100%',
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  marginTop: '20px',
  ...getScreenStyles('xs', {
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'stretch',
  }),
})

export const CardIcon = styled('span', {
  marginLeft: '3px',
})

export const ErrorContainer = styled('div', {
  marginTop: '10px',
})

export const MethodContainer = styled('div', {
  ...getScreenStyles(
    'xs',
    {},
    {
      ':not(:first-child)': {
        marginTop: '10px',
      },
    }
  ),
})

export const BeforeButtonWrapper = styled('div', {
  marginTop: '10px',
})

export const CurrencySupport = styled('div', {
  marginTop: '10px',
})
